<template>
  <div
    v-if="hasRole('ui', 'UI_ALL_COMPANIES') && selectedCompany"
    class="table__alert"
  >
    {{ $t(`${namespace}.tableMessage`) }}
    <strong>{{ selectedCompany.name }}</strong>
    {{ $t(`${namespace}.wantToSeeThemAll`) }}
    <a
      :title="$t('Common.clickHere')"
      class="text--link accent--text"
      @click.prevent="handleClearSelectedCompany"
    >
      {{ $t('Common.clickHere') }}
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'

export default {
  name: 'TableAlert',
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.CostCenterPage'
    }
  },
  methods: {
    ...mapActions({
      handleClearSelectedCompany: 'company/clearSelectedCompany'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
